module.exports = __webpack_public_path__ + "static/Moderat-Regular-723c41b26d1ee5e83008a4c70e1af56d.ttf";